module.exports = __webpack_public_path__ + "static/img/risk_down_icon.04a74b17.png";